import { render, staticRenderFns } from "./BasicText.vue?vue&type=template&id=ae5956c8"
import script from "./BasicText.vue?vue&type=script&lang=js"
export * from "./BasicText.vue?vue&type=script&lang=js"
import style0 from "./BasicText.vue?vue&type=style&index=0&id=ae5956c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports